import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { InputInformationComponent } from "./input-information.component";

const DIRECTIVES = [InputInformationComponent];

@NgModule({
	imports: [CommonModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class InputInformationModule {}
